import React, { useEffect } from 'react';
import { useMediaQuery } from '@mui/material';

const MOBILE_BREAKPOINT = 768;

function UnumSsoLoginForm(props) {
  const { calendar_image_path: calendarImagePath, sign_in_url: signInUrl, create_account_url: createAccountUrl } = props;

  useEffect(() => {
    sessionStorage.setItem('sp_initiated_sso', true);

    const sessionRedirectUrl = sessionStorage.getItem('redirect-url');
    const forceRedirection = sessionStorage.getItem('sso-redirection') == 'true';
    const hasAppropriateRedirectUrl = sessionRedirectUrl && ['/adminapp/', '/webapp/'].indexOf(sessionRedirectUrl) < 0;
    if (hasAppropriateRedirectUrl || forceRedirection) {
      window.location.href = signInUrl;
    }
  }, []);

  const isMobile = useMediaQuery(`(max-width:${MOBILE_BREAKPOINT}px)`);

  const handleSignInWithUnumClick = () => {
    window.location.href = signInUrl;
  };

  const handleCreateAccountClick = () => {
    window.location.href = createAccountUrl;
  };


  const pageStyle = isMobile ? { ...styles.page, ...styles.pageMobile } : styles.page;
  const pageLeftStyle = isMobile ? { ...styles.pageLeft, ...styles.pageLeftMobile } : styles.pageLeft;
  const pageRightStyle = isMobile ? { ...styles.pageRight, ...styles.pageRightMobile } : styles.pageRight;
  const titleStyle = isMobile ? { ...styles.title, ...styles.titleMobile } : styles.title;
  const descriptionStyle = isMobile
    ? { ...styles.description, ...styles.descriptionMobile }
    : styles.description;
  const illustrationStyle = isMobile ? { ...styles.illustration, ...styles.illustrationMobile } : styles.illustration;
  const featureTitleStyle = isMobile
    ? { ...styles.featureTitle, ...styles.featureTitleMobile }
    : styles.featureTitle;
  const featureTextStyle = isMobile
    ? { ...styles.featureText, ...styles.featureTextMobile }
    : styles.featureText;
  const buttonStyle = isMobile ? { ...styles.btn, ...styles.btnMobile } : styles.btn;

  return (
    <div style={pageStyle}>
      <div style={pageLeftStyle}>
        <img src={calendarImagePath} alt="Unum LeaveLogic calendar illustration" style={illustrationStyle} />
      </div>

      <div style={pageRightStyle}>
        <div style={styles.content}>
          <h1 style={titleStyle}>Welcome to Leave Logic</h1>
            <p style={descriptionStyle}>
              Sign in through your Unum account to review your potential benefits and plan your leave.
          </p>

          <div style={styles.actions}>
            <button type="button" style={{ ...buttonStyle, ...styles.btnPrimary }} onClick={handleSignInWithUnumClick}>
              Sign In with Unum <i className="fa fa-arrow-right" aria-hidden="true"></i>
            </button>
            <button type="button" style={{ ...buttonStyle, ...styles.btnSecondary }} onClick={handleCreateAccountClick}>Create an account</button>
          </div>

          <ul style={styles.features}>
            <li style={styles.feature}>
              <span style={styles.featureIcon}>
                <i className="fa fa-check" aria-hidden="true"></i>
              </span>
              <div>
                <p style={featureTitleStyle}>Explore your leave options</p>
                <p style={featureTextStyle}>
                  Privately explore possible leave scenarios and review information about benefits that may apply to
                  your situation.
                </p>
              </div>
            </li>

            <li style={styles.feature}>
              <span style={styles.featureIcon}>
                <i className="fa fa-check" aria-hidden="true"></i>
              </span>
              <div>
                <p style={featureTitleStyle}>Build a personalized plan</p>
                <p style={featureTextStyle}>
                  Create a leave plan tailored to your life, bringing together benefits, timelines, and required
                  steps in one place.
                </p>
              </div>
            </li>

            <li style={styles.feature}>
              <span style={styles.featureIcon}>
                <i className="fa fa-check" aria-hidden="true"></i>
              </span>
              <div>
                <p style={featureTitleStyle}>Feel confident and prepared</p>
                <p style={featureTextStyle}>
                  Know what to expect so you can feel confident and prepared at work and at home.
                </p>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    display: 'flex',
    height: '100%',
    minHeight: '100%',
    flex: 1,
    width: '100%',
    background: '#ffffff'
  },
  pageMobile: {
    flexDirection: 'column',
    minHeight: 'auto',
    height: 'auto'
  },
  pageLeft: {
    flex: '0 0 50%',
    width: '50%',
    maxWidth: '50%',
    minWidth: 0,
    background: '#015493',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 36
  },
  pageLeftMobile: {
    flex: '0 0 auto',
    width: '100%',
    maxWidth: '100%',
    padding: '22px 16px'
  },
  illustration: {
    width: '100%',
    maxWidth: 430,
    height: 'auto',
    display: 'block'
  },
  illustrationMobile: {
    maxWidth: 320
  },
  pageRight: {
    flex: '0 0 50%',
    width: '50%',
    maxWidth: '50%',
    minWidth: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '56px 56px 56px 44px',
    background: '#ffffff'
  },
  pageRightMobile: {
    flex: '0 0 auto',
    width: '100%',
    maxWidth: '100%',
    padding: '24px 20px 28px'
  },
  content: {
    maxWidth: 470
  },
  title: {
    margin: '0 0 12px',
    fontSize: 36,
    fontWeight: 400,
    lineHeight: 1.1,
    color: 'rgba(1, 82, 148, 1)'
  },
  titleMobile: {
    fontSize: 28
  },
  description: {
    margin: 0,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.5,
    color: 'rgba(82, 82, 82, 1)'
  },
  descriptionMobile: {
    fontSize: 14,
    fontWeight: 400
  },
  actions: {
    marginTop: 30,
    display: 'flex',
    gap: 12,
    flexWrap: 'wrap'
  },
  btn: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 8,
    borderRadius: 8,
    width: 198,
    height: 40,
    fontSize: 16,
    lineHeight: '24px',
    textDecoration: 'none',
    cursor: 'pointer',
    fontWeight: 600,
    border: '1px solid transparent'
  },
  btnMobile: {
    width: '100%'
  },
  btnPrimary: {
    background: 'rgba(1, 82, 148, 1)',
    borderColor: 'rgba(1, 82, 148, 1)',
    color: '#ffffff'
  },
  btnSecondary: {
    background: '#ffffff',
    border: '2px solid rgba(1, 82, 148, 1)',
    color: 'rgba(1, 82, 148, 1)'
  },
  features: {
    margin: '30px 0 0',
    padding: 0,
    listStyle: 'none',
    display: 'flex',
    flexDirection: 'column',
    gap: 18
  },
  feature: {
    display: 'flex',
    gap: 12,
    alignItems: 'flex-start'
  },
  featureIcon: {
    width: 40,
    height: 40,
    flexShrink: 0,
    borderRadius: '50%',
    background: 'rgba(175, 214, 123, 1)',
    color: 'rgba(98, 137, 46, 1)',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: 12,
    marginTop: 2
  },
  featureTitle: {
    margin: 0,
    fontSize: 16,
    lineHeight: '20px',
    fontWeight: 600,
    color: 'rgba(46, 46, 46, 1)'
  },
  featureTitleMobile: {
    fontSize: 14
  },
  featureText: {
    margin: '4px 0 0',
    fontSize: 14,
    lineHeight: '20px',
    fontWeight: 400,
    color: 'rgba(82, 82, 82, 1)'

  },
  featureTextMobile: {
    fontSize: 12,
    lineHeight: '16px'
  }
};

export default UnumSsoLoginForm;
